"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMortgageAffordByIncomeInputs = exports.defaultMortgageAffordInputs = exports.defaultMortgageInput = exports.defaultMortgageCommonInput = exports.defaultMortgageRateTableInput = exports.defaultMortgageRefinancingInput = exports.defaultDoubleAdValoremStampDutyRateTable = exports.defaultDoubleAdValoremStampDutyRateTableOld = exports.defaultSpecialStampDutyRateTable = exports.STRESS_TEST_INCREASE_PERCENT = exports.DEFAULT_INTEREST_RATE = void 0;
var MortgageInsuranceTable_init_1 = require("./MortgageInsuranceTable.init");
var MortgageLimitTable_init_1 = require("./MortgageLimitTable.init");
exports.DEFAULT_INTEREST_RATE = 3.5;
exports.STRESS_TEST_INCREASE_PERCENT = 2;
exports.defaultSpecialStampDutyRateTable = [
    { month: 6, r: 20 },
    { month: 12, r: 15 },
    { month: 36, r: 10 }
];
exports.defaultDoubleAdValoremStampDutyRateTableOld = [
    { value: 21739120, k: 0, m: 0, r: 4.25 },
    { value: 20000000, k: 750000, m: 20000000, r: 10 },
    { value: 6720000, k: 0, m: 0, r: 3.75 },
    { value: 6000000, k: 180000, m: 6000000, r: 10 },
    { value: 4428570, k: 0, m: 0, r: 3 },
    { value: 4000000, k: 90000, m: 4000000, r: 10 },
    { value: 3290320, k: 0, m: 0, r: 2.25 },
    { value: 3000000, k: 45000, m: 3000000, r: 10 },
    { value: 2351760, k: 0, m: 0, r: 1.5 },
    { value: 2000000, k: 100, m: 2000000, r: 10 },
    { value: 0, k: 100, m: 0, r: 0 }
];
exports.defaultDoubleAdValoremStampDutyRateTable = [
    { value: 21739120, k: 0, m: 0, r: 4.25 },
    { value: 20000000, k: 750000, m: 20000000, r: 10 },
    { value: 10080000, k: 0, m: 0, r: 3.75 },
    { value: 9000000, k: 270000, m: 9000000, r: 10 },
    { value: 6642860, k: 0, m: 0, r: 3 },
    { value: 6000000, k: 135000, m: 6000000, r: 10 },
    { value: 4935480, k: 0, m: 0, r: 2.25 },
    { value: 4500000, k: 67500, m: 4500000, r: 10 },
    { value: 3528240, k: 0, m: 0, r: 1.5 },
    { value: 3000000, k: 100, m: 3000000, r: 10 },
    { value: 0, k: 100, m: 0, r: 0 }
];
exports.defaultMortgageRefinancingInput = {
    outstandingMortgage: 4000000,
    currentTenor: 15,
    existingInterestRate: exports.DEFAULT_INTEREST_RATE,
    newPropertyValue: 8000000,
    newLoan: 4800000,
    newTenor: 20,
    newInterestRate: exports.DEFAULT_INTEREST_RATE,
    specialStampDutyRateTable: exports.defaultSpecialStampDutyRateTable,
    doubleAdValoremStampDutyRateTable: exports.defaultDoubleAdValoremStampDutyRateTable
};
exports.defaultMortgageRateTableInput = {
    yearStart: 10,
    yearLength: 30,
    yearStep: 5,
    rateStart: 1,
    rateLength: 5,
    rateStep: 0.25
};
exports.defaultMortgageCommonInput = {
    tenor: 30,
    interestRate: exports.DEFAULT_INTEREST_RATE,
    buyerStampDuty: false,
    adValoremStampDuty: false,
    hasOutstandingMortgage: false,
    lastTransactionInMonth: -1,
    commissionRate: 1,
    buyerStampDutyRate: 15,
    adValoremStampDutyRate: 15,
    specialStampDutyRateTable: exports.defaultSpecialStampDutyRateTable,
    doubleAdValoremStampDutyRateTable: exports.defaultDoubleAdValoremStampDutyRateTable,
    mortgagePlanList: MortgageInsuranceTable_init_1.defaultMortgageInsuranceTableCounterCycle,
    mortgagePlanListWithProperty: MortgageInsuranceTable_init_1.defaultMortgageInsuranceTableCounterCycleWithProperty,
    mortgageLimitTable: MortgageLimitTable_init_1.defaultMortgageLimitTable,
    legalAmount: 10000,
    isInsuranceMonthlyRepay: false,
    rateTableInputs: exports.defaultMortgageRateTableInput
};
exports.defaultMortgageInput = __assign(__assign({}, exports.defaultMortgageCommonInput), { propertyValue: 8000000, downPayment: 800000 });
exports.defaultMortgageAffordInputs = __assign(__assign({}, exports.defaultMortgageCommonInput), { monthlyPayment: 20000, downPayment: 2000000, interestRate: exports.DEFAULT_INTEREST_RATE + exports.STRESS_TEST_INCREASE_PERCENT });
exports.defaultMortgageAffordByIncomeInputs = __assign(__assign({}, exports.defaultMortgageAffordInputs), { monthlyIncome: 40000, interestRate: exports.DEFAULT_INTEREST_RATE, monthlyPayment: 0, debtServiceRatio: 0.5, stressTestIncreasePercent: exports.STRESS_TEST_INCREASE_PERCENT });
